import { useEffect, useState } from 'react';
import { aoBasisgegevensSettings } from '../../../../../common/src/domain/customInspectionTypes/amsterdamOverspanningen/basisgevens/aoBasisgegevensSettings';
import { fetchGet } from '../../../store/fetch';
import { openApiFetchGet, openApiFetchPost } from '../../../store/openApiFetch';

export function useInspectieOverspanningenState<BasisgevensState extends Record<string, any>, UnitDataState>(
    surveyId: string,
    unitId: string,
    objectId: string,
) {
    const [formState, setFromState] = useState<UnitDataState | undefined>();
    const [basisgegevensState, setBasisgegevens] = useState<BasisgevensState>({} as BasisgevensState);

    useEffect(() => {
        async function load() {
            const surveys = await fetchGet('/api/surveys', {
                objectId,
                inspectionStandardType: aoBasisgegevensSettings.inspectionStandardType,
            });
            if (surveys.json.items.length > 0) {
                const basisgegevensSurveyId = surveys.json.items[0].id;

                const basisgegevensData = await openApiFetchGet(
                    '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/basisgegevens',
                    { surveyId: basisgegevensSurveyId, unitId },
                );
                setBasisgegevens(basisgegevensData);
            }

            const inspectieData = await openApiFetchGet(
                '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/inspectieOverspanningen',
                { surveyId, unitId },
            );
            setFromState(inspectieData);
        }
        setFromState(undefined);
        void load();
    }, [surveyId, unitId, objectId]);

    async function save(data: UnitDataState) {
        await openApiFetchPost(
            '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/inspectieOverspanningen',
            { surveyId, unitId },
            data,
        );
    }

    return { formState, basisgegevensState, setFromState, save };
}
